/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import SessionByReffererChart from './SessionByReffererChart';
import { sortByOptionsForShopifyRefferer } from '../../helper'


const SessionByReffererShow = ({ dir, data, viewReportButton, title, optionShow, companyBasedOn }) => {
  const thisMonthData = {};
  const currentDataByReferrerName = {};

  const [sortBySelected, setSortBySelected] = useState(sortByOptionsForShopifyRefferer[1])

  const allCategories = {}
      let currentYearMonthDayWise = {};
  
      const reduceCallbackForDaily = (acc, day) => {
          const date = moment(`${day.salesMonth}-${day?.day}-${day?.salesYear}`, 'MMM-D-YYYY');
  
          const dateWithMonthYear = date.format('D-MMM-YYYY-DDD');
  
          if (acc[dateWithMonthYear]) {
              acc?.[dateWithMonthYear]?.push(day)
          } else {
              acc[dateWithMonthYear] = [day]
          }
  
          if (day && !allCategories[day?.referrerName]) {
               if (!day?.referrerName || day?.referrerName === 'null') {
                  allCategories['N/A'] = 'N/A';
              } else {
                  allCategories[day?.referrerName] = day?.referrerName
              }
          }
  
  
          return acc
      }

      const reduceCallbackForMonthly = (acc, day) => {
        const monthData = `${day.salesMonth}-${day?.salesYear}`;
        if (acc[monthData]) {
          acc?.[monthData]?.push(day)
        } else {
          acc[monthData] = [day]
        }    

        if (day && !allCategories[day?.referrerName]) {
            if (!day?.referrerName || day?.referrerName === 'null') {
               allCategories['N/A'] = 'N/A';
           } else {
               allCategories[day?.referrerName] = day?.referrerName
           }
       }
        return acc
      }

      if (optionShow?.value === 'daily'){
        currentYearMonthDayWise = data?.reduce(reduceCallbackForDaily, {}) ?? {}
       }
       else {
        currentYearMonthDayWise = data?.reduce(reduceCallbackForMonthly, {}) ?? {}
       }
    //  salesBreakdownByDay = data?.reduce(reduceCallback, {}) ?? {};
      let dataToPlot = Object.keys(currentYearMonthDayWise).map((key) => {
          const daySalesArr = currentYearMonthDayWise[key];
          const currentDayByCategory = {};
          const [day, month, year, dayofyear] = key.split('-');
  
          let totalAmount = 0
          daySalesArr?.forEach((item) => {
              if (item && currentDayByCategory[item?.referrerName]) {
                  currentDayByCategory[item?.referrerName]?.push(item);
              } else if (item && (!item?.referrerName || item?.referrerName === 'null')) {
                  if (currentDayByCategory['N/A']) {
                      currentDayByCategory['N/A']?.push(item)
                  } else {
                      currentDayByCategory['N/A'] = [item]
                  }
              } else {
                  currentDayByCategory[item?.referrerName] = [item]
              }
          });

          let currentMonthDataKey = '';
          if (optionShow?.value === 'daily'){
            currentMonthDataKey = `${day}, ${month} ${year}`;
           }
           else {
            currentMonthDataKey = `${day}, ${month}`;
           }
  
          return Object.keys(currentDayByCategory).reduce((acc, categ) => {
              const amount = currentDayByCategory[categ]?.reduce((accum, item) => Number(Number(Number(accum) +
                  Number(item?.totalSessions)).toFixed(2)), 0);
              totalAmount += amount;
              acc[categ] = amount;
              acc.Amount = totalAmount;
              acc.day = `${month}-${day}-${year}`;
              acc.currentMonthDataKey = currentMonthDataKey
              return acc
          }, {})
      })  
const sortBy = sortBySelected?.value;
  if (sortBy === 'title') {
      dataToPlot = dataToPlot?.sort((a, b) =>
          a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
  } else {
      dataToPlot = dataToPlot?.sort((a, b) =>
          a?.[sortBy] < b?.[sortBy] ? 1 : -1)
  }

    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }} >
                <h5 className="bold-text col-md-7">{title}</h5>                
                <div className="col-5" id='dvChartView'>
                    {viewReportButton?.()}
                    </div>
                </div>
                {dataToPlot?.length ? (                   
                <Row style={{paddingTop: 50}}>                   
                    <Col sm={12} md={12}>
                        <SessionByReffererChart dir={dir}
                          totalDays={365}
                          dataToShow={dataToPlot}
                          height={1000}
                          showTitle={false}
                          allCategories={allCategories}                        
                        /> 
                        </Col>
                </Row>
            ) : 'No data to display'}
            </Card>
        </Col>

    )
}

SessionByReffererShow.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    optionShow: PropTypes.object.isRequired,
    companyBasedOn: PropTypes.string
};

SessionByReffererShow.defaultProps = {
    title: 'Session By Refferer',
    companyBasedOn: 'companyName',
}

export default SessionByReffererShow;
